module.exports = __webpack_public_path__ + "img/key.09c50236.svg";